import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, FormGroup, FormFeedback, Input, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import store from 'redux-store/store'
import Select from 'react-select';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import FormSection from '../../../layout/FormSection';
import { API, BASE_URL, ROLES_ASEGURADO, ROLES_CORREDOR, ESTADOS_LINEAS, ESTADOS_DEUDOR } from '../../../../CONST';
import { tiposDeudorToOptions } from '../../../../helpers/selects';
import { roundInt, userHasRole } from '../../../../helpers/helpers';
import { get } from '../../../../helpers/requests';
import FileTable from '../../../shared/FileTable';
import CreditLineClientForm from './CreditLineClientForm';
import FileUploader from '../../../shared/FileUploader';
import Icon from "../../../UI/Icon";

const CreditLineForm = ({
  linea: {
    deudor,
    tipo_deudor: tipoDeudor,
    balance: {
      monto_vigente: montoLineaVigente,
      monto_solicitado: montoSolicitado,
      limite_apelacion: limiteApelacion,
      observacion,
      documentos,
      carpeta_tributaria: carpetaTributaria,
      fecha_solicitud: fechaSolicitud
    },
    estado_data: estadoData,
  },
  maximoInnominados,
  setLinea,
  edicion,
  tiposDeudor,
  paises,
  onPaisChange,
  handleMontoSolicitadoChange,
  handleSaveLinea,
  handleEditionCancel,
  loadingTiposDeudor,
  setLineaProperty,
  handleDeudorRutChange,
  handleSaveDeudor,
  savingDeudor,
  clearDeudor,
  deudorStepComplete,
  solicitada,
  handleSolicitada,
  isUnlock,
  isPolizaVigente,
  getUmbralMinimo,
  maximoInnominadosAmt,
  isSiipreloadLoading,
  isOnBorrador,
  client,
  policyId,
  policyIsExportacion,
  policyState,
  policyTerminoVigencia,
  policyMoneda,
}) => {
  const apelacion = !!limiteApelacion;
  const {user} = store.getState().login
  const loginIdToken = useSelector((state) => state.login.id_token);
  const tiposDeudorOptions = tiposDeudorToOptions(tiposDeudor);
  const tipoDeudorOption = tipoDeudor
    ? tiposDeudorOptions.find((tdo) => tdo.value.id === tipoDeudor.id)
    : null;
  // 'deudor.linea_vigente' es el cúmulo total de líneas vigentes del deudor.
  const lineaDisponible = deudor.techo_vigente - deudor.linea_vigente + montoLineaVigente;
  const [lastEndosoCredito, setEndosoCredito] = useState([]);
  const [uploadingCarpetaTributaria, setUploadingCarpetaTributaria] = useState(false);
  const [originalUnlockAmount, setOriginalUnlockAmount] = useState(null);

  const daysSince = (dateString) => {
    if (!dateString) return 0;
    const [day, month, year] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    const result = (Date.now() - date.getTime()) / (24 * 60 * 60 * 1000);
    return result;
  };

const isOlderThan60Days = () => {
  const days = daysSince(fechaSolicitud);
  return days > 60;
};

  const hasChangedUnlockAmount = () => {
    return isUnlock && originalUnlockAmount !== null && montoSolicitado !== originalUnlockAmount;
  };

  const willBeReestudio = () => {
    return isUnlock && (hasChangedUnlockAmount() || isOlderThan60Days());
  };

  useEffect(() => {
    if (policyId){
    const lastEndosoCreditoPoliza = `${BASE_URL}${API.simpleEndososCredito}/?poliza_id=${policyId}&get_last_including_borrador=true`;
    get(client ? `${lastEndosoCreditoPoliza}&client_id=${client.id}` : lastEndosoCreditoPoliza)
      .then((resp) => {
        if (resp && resp.length > 0) {
            const sortedByIdDesc = [...resp].sort((a, b) => b.id - a.id);
            const latestEndoso = sortedByIdDesc[0];
            setEndosoCredito(latestEndoso);
        }
      })
    }
  }, [policyId]);

  useEffect(() => {
    if (isUnlock && montoSolicitado !== undefined && originalUnlockAmount === null) {
      setOriginalUnlockAmount(montoSolicitado);
    }
  }, [isUnlock, montoSolicitado, originalUnlockAmount]);

  const isDisabled = () => {
    return (
      // !isPolizaVigente()  ||
      !deudor.id ||
      !tipoDeudor ||
      montoSolicitado === undefined ||
      montoSolicitado <= montoLineaVigente ||
      montoSolicitado < getUmbralMinimo ||
      //deudor.estado === ESTADOS_DEUDOR.bloqueado ||
      //(apelacion && montoSolicitado > limiteApelacion)  ||
      (tipoDeudor.nemotecnico==='innominado' && montoSolicitado > maximoInnominados) ||
      (
        deudor &&
        deudor.techo_vigente &&
        montoSolicitado > lineaDisponible &&
        user.is_orsan
      ) ||
      (
        // Si el usuario es asegurado o corredor, y la línea obtenida al ingresar el rut
        // de un deudor está pendiente, no dejará hacer la solicitud de línea.
        ((userHasRole(user, ROLES_CORREDOR) || userHasRole(user, ROLES_ASEGURADO)) && !user.is_orsan) && (
          estadoData && estadoData.nemotecnico === ESTADOS_LINEAS.pendiente
        )
      ) ||
      uploadingCarpetaTributaria
    )
  }
  
  return (
    <FormSection title="Carga Individual">
      <CreditLineClientForm
        deudor={deudor}
        setDeudor={(name, value) => setLineaProperty(`deudor.${name}`, value)}
        handleRutChange={handleDeudorRutChange}
        handleSaveDeudor={handleSaveDeudor}
        savingDeudor={savingDeudor}
        clearDeudor={clearDeudor}
        deudorStepComplete={deudorStepComplete}
        isUnlock={isUnlock}
        isSiipreloadLoading={isSiipreloadLoading}
        policyIsExportacion={policyIsExportacion}
        paises={paises}
        onPaisChange={onPaisChange}
      />
      {deudorStepComplete && (
        <>
          <hr className="form-separator" />
          <Form onSubmit={handleSaveLinea}>
            <FormGroup row>
              <Label for="tipo-deudor" sm={4}>
                Tipo Deudor
              </Label>
              <Col sm={8}>
                <Select
                  id="tipo-deudor"
                  name="tipoDeudor"
                  className="orsan-form-element"
                  value={tipoDeudorOption}
                  onChange={(selectedOption) => {
                    setLinea((prevState) => ({
                      ...prevState,
                      tipo_deudor: selectedOption.value,
                    }));
                  }}
                  options={tiposDeudorOptions}
                  placeholder="Seleccione tipo deudor"
                  isLoading={loadingTiposDeudor}
                  isDisabled={isUnlock}
                />
              </Col>
            </FormGroup>
            {((!userHasRole(user, ROLES_CORREDOR) && !userHasRole(user, ROLES_ASEGURADO)) || user.is_orsan) && deudor && deudor.techo_vigente && (
              <>
                <FormGroup row>
                  <Label for="techo-vigente" sm={4}>
                    Techo Vigente ({policyMoneda})
                    <Icon
                      id='check-techo-vigente'
                      placement="right"
                      tooltipText={`Cúmulo máximo que puede solicitar un deudor en ${policyMoneda}. Este valor se puede modificar desde el módulo de Riesgo de Crédito al editar un deudor.`}
                      className="float-right"
                    >
                      <FontAwesomeIcon style={{color: "var(--orsan-blue)"}} icon={faQuestionCircle} />
                    </Icon>
                  </Label>
                  <Col sm={8}>
                    <Input
                      id="techo-vigente"
                      className="orsan-form-element"
                      value={(deudor && roundInt(deudor.techo_vigente))}
                      style={{ padding: '6px 12px' }}
                      plaintext
                      disabled
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="monto-vigente" sm={4}>
                    Cúmulo vigente
                    <Icon
                      id='check-monto-vigente'
                      placement="right"
                      tooltipText="Cúmulo vigente que tiene el deudor. Este valor es la suma de todas las líneas vigentes solicitadas por un deudor."
                      className="float-right"
                    >
                      <FontAwesomeIcon style={{color: "var(--orsan-blue)"}} icon={faQuestionCircle} />
                    </Icon>
                  </Label>
                  <Col sm={8}>
                    <Input
                      id="monto-vigente"
                      className="orsan-form-element"
                      value={roundInt(deudor.linea_vigente)}
                      style={{ padding: '6px 12px' }}
                      plaintext
                      disabled
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="linea-disponible" sm={4}>
                    Cúmulo disponible
                    <Icon
                      id='check-linea-disponible'
                      placement="right"
                      tooltipText="Cúmulo disponible para solicitar nueva línea. Este valor se calcula como Techo Vigente - Cúmulo Vigente + Línea Vigente."
                      className="float-right"
                    >
                      <FontAwesomeIcon style={{color: "var(--orsan-blue)"}} icon={faQuestionCircle} />
                    </Icon>
                  </Label>
                  <Col sm={8}>
                    <Input
                      id="linea-disponible"
                      className="orsan-form-element"
                      value={roundInt(lineaDisponible)}
                      style={{ padding: '6px 12px' }}
                      plaintext
                      disabled
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            <FormGroup row>
              <Label for="monto-vigente" sm={4}>
                Línea Vigente ({policyMoneda})
              </Label>
              <Col sm={8}>
                <Input
                  id="monto-vigente"
                  className="orsan-form-element"
                  value={roundInt(montoLineaVigente)}
                  style={{ padding: '6px 12px' }}
                  plaintext
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="monto-solicitado" sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>Nueva Línea Solicitada ({policyMoneda})</span>
                {isUnlock && (() => {
                  return (
                    <Icon
                      id='reestudio-warning'
                      placement="right"
                      tooltipText={
                        willBeReestudio() 
                          ? `Esta solicitud será procesada como Reestudio porque:${
                              hasChangedUnlockAmount() ? '\n• Se modificó el monto de desbloqueo' : ''
                            }${
                              isOlderThan60Days() ? '\n• La solicitud tiene más de 60 días de antigüedad' : ''
                            }`
                          : "Al modificar este monto, la solicitud será procesada como Reestudio en lugar de Desbloqueo."
                      }
                    >
                      <FontAwesomeIcon style={{color: "var(--orsan-orange)"}} icon={faExclamationTriangle} />
                    </Icon>
                  );
                })()}
              </Label>
              <Col sm={8}>
                <NumberFormat
                  id="monto-solicitado"
                  className="form-control orsan-form-element"
                  placeholder="0"
                  onValueChange={handleMontoSolicitadoChange}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale="0"
                  allowNegative={false}
                  value={montoSolicitado}
                />
                {((!userHasRole(user, ROLES_CORREDOR) && !userHasRole(user, ROLES_ASEGURADO)) || user.is_orsan) &&
                deudor && deudor.techo_vigente && montoSolicitado > lineaDisponible && (
                  <FormFeedback>El monto solicitado no debe sobrepasar el cúmulo de línea disponible.</FormFeedback>
                )}
                {montoSolicitado !== undefined && montoSolicitado <= montoLineaVigente && (
                  <FormFeedback>El monto solicitado debe ser superior a la línea vigente de {montoLineaVigente} {policyMoneda}.</FormFeedback>
                )}
                {/*
                {apelacion && montoSolicitado > limiteApelacion && (
                  <FormFeedback>
                    El monto solicitado en apelación debe ser menor o igual al rechazado anteriormente
                    {' ('.concat(limiteApelacion).concat(` ${policyMoneda})`)}
                  </FormFeedback>
                )}
                */}
                {tipoDeudor?.nemotecnico==='innominado' && montoSolicitado > maximoInnominados && montoSolicitado > maximoInnominados && (
                  <FormFeedback>
                    El monto solicitado supera el límite para deudores innominados de {maximoInnominados} {policyMoneda}
                  </FormFeedback>
                )}
                {montoSolicitado < getUmbralMinimo && (
                  <FormFeedback>
                    El monto solicitado debe ser superior al umbral de cobertura de {getUmbralMinimo} de la póliza
                  </FormFeedback>
                )}
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="observacion" sm={4}>
                Observación
              </Label>
              <Col sm={8}>
                <Input
                  type="textarea"
                  id="observacion"
                  value={observacion}
                  onChange={(e) =>
                    setLinea((prevState) => ({
                      ...prevState,
                      balance: {
                        ...prevState.balance,
                        observacion: e.target.value,
                      },
                    }))
                  }
                />
              </Col>
            </FormGroup>
            {!policyIsExportacion && (
              <FormGroup row>
                <Label for="carpeta-tributaria" sm={4}>
                  Carpeta Tributaria
                </Label>
                <Col sm={8}>
                  <FileUploader
                    inputId="carpeta-tributaria-id"
                    uploadUrl={`${BASE_URL}${API.uploadDocumento}/`}
                    inputText="Seleccione un archivo (.pdf)"
                    accept=".pdf"
                    handleResponse={(file) => {
                      setUploadingCarpetaTributaria(false);
                      setLinea((prevState) => ({
                        ...prevState,
                        balance: {
                          ...prevState.balance,
                          carpeta_tributaria: file,
                        },
                      }));
                    }}
                    handleInitUploading={() => {
                      setUploadingCarpetaTributaria(true);
                    }}
                    clearable
                    solicitada={solicitada}
                    handleSolicitada={handleSolicitada}
                    filename={carpetaTributaria ? carpetaTributaria.file : ''}
                    prefijo={deudor.rut}
                    onClearFile={() =>
                      setLinea((prevState) => ({
                        ...prevState,
                        balance: {
                          ...prevState.balance,
                          carpeta_tributaria: null,
                        },
                      }))
                    }
                  />
                </Col>
              </FormGroup>
            )}
            <FormGroup row>
              <Label for="documentos" sm={4}>
                Otros Documentos
              </Label>
              <Col sm={8}>
                <FileTable
                  newFiles={documentos}
                  handleAdd={(file) => {
                    setLinea((prevState) => ({
                      ...prevState,
                      balance: {
                        ...prevState.balance,
                        documentos: [...prevState.balance.documentos, file],
                      },
                    }));
                  }}
                  handleDeleteNew={(file) => {
                    setLinea((prevState) => ({
                      ...prevState,
                      balance: {
                        ...prevState.balance,
                        documentos: prevState.balance.documentos.filter(
                          (doc) => doc.uuid !== file.uuid,
                        ),
                      },
                    }));
                  }}
                  loginIdToken={loginIdToken}
                  uploadUrl={`${BASE_URL}${API.uploadDocumento}/`}
                  previewFileUrl={`${BASE_URL}${API.tempFileDownload}/`}
                  previewFile
                  individualMaxFileSize={13}
                  globalMaxFileSize={20}
                />
              </Col>
            </FormGroup>
            <Button
              disabled={isDisabled()}
              className="float-right"
              color="orsan-primary"
              style={{ width: '100px', fontSize: '14px' }}
            >
              {edicion ? 'Guardar' : 'Agregar'}
            </Button>
            {/*
            {deudor.estado === ESTADOS_DEUDOR.bloqueado && (
              <FormFeedback>Este deudor se encuentra en Lista Negra.</FormFeedback>
            )}
            */}
            {!isPolizaVigente() && isOnBorrador &&
             (
               policyState !== 'emitido' ||
               (policyState === 'emitido' && !moment(policyTerminoVigencia).isAfter(moment()))
             ) &&
             moment(lastEndosoCredito.termino_vigencia).isAfter(moment()) &&
             lastEndosoCredito.estado !== 'construccion' && (
               <FormFeedback>
                 * <strong>Importante:</strong> Esta póliza aún se encuentra en estado de borrador y no ha sido renovada. En caso de que la renovación no se concrete,
                 las condiciones y coberturas indicadas en este documento no tendrán validez.
               </FormFeedback>
            )}
            {edicion && (
              <Button
                className="float-right"
                color="orsan-link"
                style={{ width: '100px', fontSize: '14px' }}
                onClick={handleEditionCancel}
              >
                Cancelar
              </Button>
            )}
            {((userHasRole(user, ROLES_CORREDOR) || userHasRole(user, ROLES_ASEGURADO)) && !user.is_orsan) &&
              (estadoData && estadoData.nemotecnico === ESTADOS_LINEAS.pendiente) && (
                <FormFeedback>No puede pedir aumento de una línea pendiente.</FormFeedback>
            )}
            {(apelacion || isUnlock ) && (
              <FormFeedback style={{ color: 'var(--orsan-blue)' }}>
                Se recomienda adjuntar documentos adicionales que
                {apelacion ? ' aporten a la apelación' : willBeReestudio() ? ' justifiquen el reestudio' : ' justifiquen el desbloqueo'}
              </FormFeedback>
            )}
          </Form>
        </>
      )}
    </FormSection>
  );
};

CreditLineForm.propTypes = {
  linea: PropTypes.shape({
    cliente: PropTypes.shape({
      rut: PropTypes.string,
      nombre: PropTypes.string,
    }),
    deudor: PropTypes.shape({
      id: PropTypes.number,
      rut: PropTypes.string,
      nombre: PropTypes.string,
      techo_vigente: PropTypes.number,
      linea_vigente: PropTypes.number,
      estado: PropTypes.string,
    }),
    tipo_deudor: PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
      descripcion: PropTypes.string,
    }),
    balance: PropTypes.shape({
      monto_vigente: PropTypes.number,
      monto_solicitado: PropTypes.number,
      observacion: PropTypes.string,
      documentos_ids: PropTypes.arrayOf(PropTypes.number),
      documentos: PropTypes.arrayOf(PropTypes.object),
      carpeta_tributaria: PropTypes.object,
      limite_apelacion: PropTypes.number,
    }),
    estado_data: PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
      nombre: PropTypes.string,
    }),
  }).isRequired,
  maximoInnominados: PropTypes.number,
  setLinea: PropTypes.func.isRequired,
  tiposDeudor: PropTypes.arrayOf(
    PropTypes.shape({
      descripcion: PropTypes.string,
    }),
  ).isRequired,
  paises: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      code: PropTypes.string,
    }),
  ),
  onPaisChange: PropTypes.func,
  edicion: PropTypes.bool.isRequired,
  handleMontoSolicitadoChange: PropTypes.func.isRequired,
  handleSaveLinea: PropTypes.func.isRequired,
  handleEditionCancel: PropTypes.func.isRequired,
  loadingTiposDeudor: PropTypes.bool.isRequired,
  setLineaProperty: PropTypes.func.isRequired,
  handleDeudorRutChange: PropTypes.func.isRequired,
  handleSaveDeudor: PropTypes.func.isRequired,
  savingDeudor: PropTypes.bool.isRequired,
  clearDeudor: PropTypes.func.isRequired,
  deudorStepComplete: PropTypes.bool.isRequired,
  solicitada: PropTypes.bool.isRequired,
  handleSolicitada: PropTypes.func.isRequired,
  isUnlock: PropTypes.bool,
  isPolizaVigente: PropTypes.func.isRequired,
  isSiipreloadLoading: PropTypes.bool,
  isOnBorrador: PropTypes.bool,
  policyId: PropTypes.number.isRequired,
  policyIsExportacion: PropTypes.bool.isRequired,
  policyState: PropTypes.string.isRequired,
  policyTerminoVigencia: PropTypes.string.isRequired,
  policyMoneda: PropTypes.string.isRequired,
};

CreditLineForm.defaultProps = {
  isUnlock: false,
  maximoInnominados: 0,
  isSiipreloadLoading: false,
  paises: [],
  onPaisChange: () => {},
}


export default CreditLineForm;
